import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class AssignGradingResponse extends GlobalResponseObject{
    data?: boolean;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: boolean){
        super(status,intlCode,internalMessage)
        this.data = data;
    }

}